import React, { useEffect } from "react";
import {Box, Container, Fab, CircularProgress, useMediaQuery} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from 'react-i18next';
import { useAppBar } from '../../providers/AppBarProvider';

const EditPage = ({ 
  children, 
  onSubmit, 
  isLoading,
}) => {
  const { t } = useTranslation();
  const { toggleCloseIcon } = useAppBar();

  useEffect(() => {
    toggleCloseIcon(true);
    
    // Cleanup function to hide the close icon when component unmounts
    return () => {
      toggleCloseIcon(false);
    };
  }, [toggleCloseIcon]); // Solo depende de toggleCloseIcon

  const isSmallScreen = useMediaQuery('(max-width:900px)');
  const assistantWidth = 360;

  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        px: { xs: 1.5, sm: 2, md: 3 },
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Box 
        component="form" 
        onSubmit={onSubmit} 
        sx={{ position: "relative", mb: 4, width: '100%', overflowX: 'hidden' }}
      >
        {children}

        {(isLoading) && (
          <>
            <CircularProgress
              size={42}
              // sx={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-21px', marginLeft: '-21px' }}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          </>
        )}

        {/* Floating Action Button */}
        {onSubmit && (
          <Box
            sx={{
              position: "fixed",
              bottom: 16,
              right: isSmallScreen ? 16 : 16 + assistantWidth,
              zIndex: 1000,
            }}
          >
            <Fab color="primary" aria-label={t('common.save')} onClick={onSubmit} disabled={isLoading}>
              <CheckIcon />
            </Fab>
          </Box>
        )}

      </Box>
    </Container>
  );
};

export default EditPage;
